import React, { useState } from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import {
  decrement,
  increment,
  incrementByAmount,
  incrementAsync,
  incrementIfOdd,
  selectTag,
} from './tagSlice';

export function Tags() {
  const dispatch = useAppDispatch();
  const [incrementAmount, setIncrementAmount] = useState('4');

  const incrementValue = Number(incrementAmount) || 0;

  const handleClick = () => {
	  console.log('You clicked the chip');
  }
  const handleDelete = () => {
	  console.log('You clicked the delete');
  }

  return (
    <div>
		<Stack direction="row" spacing={1}>
			<Chip
				label="clickable"
				onClick={handleClick}
				onDelete={handleDelete}
			/>
			<Chip
				label="clickable"
				onClick={handleClick}
				onDelete={handleDelete}
			/>
			<Chip
				label="clickable"
				onClick={handleClick}
				onDelete={handleDelete}
			/>
			<Chip
				label="clickable"
				onClick={handleClick}
				onDelete={handleDelete}
			/>
			<Chip
				label="clickable"
				onClick={handleClick}
				onDelete={handleDelete}
			/>
		</Stack>
    </div>
  );
}
